<template>
  <v-list dense>
    <v-divider></v-divider>
    <h4 class="text-xs-center my-4" color="blue-grey lighten-1">Informações Complementares</h4>
    <v-list-tile v-if="user.birthday">
      <v-list-tile-content>Data de Nacimento:</v-list-tile-content>
      <v-list-tile-content class="align-end">
        {{ user.birthday | moment('DD/MM/YYYY') }}
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if="user.gender">
      <v-list-tile-content>Genero:</v-list-tile-content>
      <v-list-tile-content class="align-end">
        <span v-if="user.gender == 'male'">Masculino</span>
        <span v-if="user.gender == 'female'">Feminino</span>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if="user.stature">
      <v-list-tile-content>Estatura:</v-list-tile-content>
      <v-list-tile-content class="align-end">
        {{ user.stature }}cm
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if="user.document_number">
      <v-list-tile-content>CPF:</v-list-tile-content>
      <v-list-tile-content class="align-end">
        {{ user.document_number }}
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if="user.document">
      <v-list-tile-content>RG:</v-list-tile-content>
      <v-list-tile-content class="align-end">
        {{ user.document }}
      </v-list-tile-content>
    </v-list-tile>

    <v-list-tile v-if="address.city && address.state">
      <v-list-tile-content>Cidade/Estado:</v-list-tile-content>
      <v-list-tile-content class="align-end">
        {{ address.city }} - {{ address.state }}
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if="address.zip">
      <v-list-tile-content>CEP:</v-list-tile-content>
      <v-list-tile-content class="align-end">
        {{ address.zip }}
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if="address.street">
      <v-list-tile-content>Endereço:</v-list-tile-content>
      <v-list-tile-content class="align-end">
        {{ address.street }}, {{ address.number }}.
        <span v-if="address.neighborhood">Bairro: {{ address.neighborhood }}</span>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-if="address.complement">
      <v-list-tile-content>Complemento:</v-list-tile-content>
      <v-list-tile-content class="align-end">
        {{ address.complement }}
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
export default {
  name: 'UserMoreInformations',
  props: ['user', 'address']
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserMoreInformations.vue